import type { Actor as ActorType, OrgUser } from "scantling-common";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface ActorProps {
  actor: ActorType | null | undefined;
  users?: Map<string, OrgUser>;
  size?: "sm" | "default" | "lg";
  showName?: boolean;
}

export function Actor({
  actor,
  users,
  size = "sm",
  showName = true,
}: ActorProps) {
  if (!actor) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  if (actor.type === "machine") {
    return (
      <span className="text-xs text-muted-foreground">{actor.apiKey}</span>
    );
  }

  const user = users?.get(actor.userId);
  const initials = user
    ? `${user.firstName?.[0] ?? ""}${user.lastName?.[0] ?? ""}`.toUpperCase() ||
      user.email?.[0]?.toUpperCase() ||
      "?"
    : "?";
  const name =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : (user?.email ?? null);

  return (
    <div className="flex items-center gap-2">
      <Avatar size={size}>
        {user?.imageUrl && (
          <AvatarImage src={user.imageUrl} alt={name ?? "User"} />
        )}
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      {showName && name && <span className="text-xs">{name}</span>}
    </div>
  );
}
